/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NatureFxWaterDropIcon16Solid = forwardRef('NatureFxWaterDropIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.152 1.269a1.22 1.22 0 0 1 1.696 0c.571.55 1.774 1.77 2.84 3.24C12.73 5.946 13.75 7.769 13.75 9.5a5.75 5.75 0 1 1-11.5 0c0-1.731 1.02-3.554 2.062-4.991 1.066-1.47 2.269-2.69 2.84-3.24Zm4.341 8.01c-.061-.965-1.558-.87-1.497.095.077 1.211-.988 2.238-2.197 2.116-.962-.097-1.112 1.395-.15 1.492 2.114.213 3.978-1.583 3.844-3.703Z" })));
});
